import { Skeleton, TableCell, TableRow } from '@mui/material';

export const TableLoadingSkeleton = (props: TableLoadingSkeletonProps): JSX.Element => {
    return (
        <>
            {Array.from({ length: props.rows }).map((_, i) => (
                <TableRow key={i}>
                    {Array.from({ length: props.columns }).map((_, j) => (
                        <TableCell key={j}>
                            <Skeleton animation="wave" variant="text" />
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </>
    );
};

export type TableLoadingSkeletonProps = {
    rows: number;
    columns: number;
};
